/**
 * <LiveEngagementScoreAlerts> — the "points d'attention" block (molecule, L0.1).
 *
 * The curated engagement alerts surfaced on top of the score card: a "⚠️ Points d'attention" title
 * over one generic `<AlertCard>` per signal. This is where the domain `UIEngagementAlert` (its
 * recurrence emphasis + expandable detail) is composed into the generic card — the card itself stays
 * domain-agnostic. Renders nothing when there are no alerts. No hex.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { AlertCard } from "../AlertCard"
import { type UIEngagementAlert } from "../../../ports/primary/ui/types"

export type LiveEngagementScoreAlertsProps = {
    alerts: UIEngagementAlert[]
    testID?: string
}

export function LiveEngagementScoreAlerts(props: LiveEngagementScoreAlertsProps) {
    const { alerts, testID } = props

    if (alerts.length === 0) return null

    return (
        <Stack gap="2" testID={testID}>
            <Text size="text-xs" weight="bold" color="text-muted" uppercase>
                ⚠️ Points d&apos;attention
            </Text>
            {alerts.map((alert, index) => (
                <AlertCard
                    key={index}
                    severity={alert.severity}
                    message={
                        alert.recurrenceCount != null && alert.recurrenceCount > 0 ? (
                            <>
                                {alert.message}
                                <Text size="text-xs" weight="bold" color="text-danger">
                                    {`  · ${alert.recurrenceCount}ᵉ séance consécutive`}
                                </Text>
                            </>
                        ) : (
                            alert.message
                        )
                    }
                    accordionBody={
                        alert.detail != null && alert.detail !== "" ? (
                            <Text size="text-sm" color="text-muted">
                                {alert.detail}
                            </Text>
                        ) : undefined
                    }
                />
            ))}
        </Stack>
    )
}
